module.exports = require('./shorthash');


//////////////////
// WEBPACK FOOTER
// ./~/shorthash/index.js
// module id = 159
// module chunks = 0